export enum TrustNumber {
  EIN = 'EIN',
  SSN = 'Social Security number',
}
